import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayUpdateUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/gateway-update-user.model';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { UserUpdateFormStep1Controller } from '@app/feature/user/user-update/user-update-form-step-1/user-update-form-step-1.controller';
import { useUpdateUserContext } from '@app/feature/user/user.context';

export interface UserUpdateFormControllerProps {
  onError: SubmitErrorHandler<{
    userId: GatewayUserModel['id'];
    user: GatewayUpdateUserModel;
  }>;
  onSubmit: SubmitHandlerWithDirtyFields<{
    userId: GatewayUserModel['id'];
    user: GatewayUpdateUserModel;
  }>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const UserUpdateFormController = (
  props: UserUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useUpdateUserContext();

  return (
    <MultiStepFormProvider<{
      userId: GatewayUserModel['id'];
      user: GatewayUpdateUserModel;
    }>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.user-update.step-1.title'),
          iconName: 'user-01',
          fields: [
            'user.lastName',
            'user.firstName',
            'user.mobileNumber',
            'user.landlineNumber',
          ],
          component: <UserUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
